import configService from "../../account/src/services/config";
import { API } from "../../account/src/api/apiEndPoints.js";
import { askIQStream } from "../../account/src/api/askIQApi";
import {
  buildIQSuggestionPayload,
  isControlledIQSuggestOverlayType,
  suggestionTypeForOverlayType,
} from "./buildIQSuggestionPayload";

/**
 * Best-effort hygiene: reset the backend refinement session (start_new) when the user
 * confirms exit from a controlled IQ suggest overlay. Failures are swallowed.
 */
export function resetIQSuggestionSession({ type, prompt, roleId, responsibilityId }) {
  if (!prompt || !isControlledIQSuggestOverlayType(type)) {
    return Promise.resolve();
  }

  const iqBaseUrl = (configService.get("iqBaseUrl") || "").trim().replace(/\/$/, "");
  if (!iqBaseUrl) {
    return Promise.resolve();
  }

  const suggestionType = suggestionTypeForOverlayType(type);
  const url = `${iqBaseUrl}/${API.GET_SUGGESTIONS}`;
  const customPayload = buildIQSuggestionPayload({
    prompt,
    suggestionType,
    roleId,
    responsibilityId,
    startNew: true,
  });

  return askIQStream({
    question: prompt,
    customEndpoint: url,
    customPayload,
  }).catch(() => {
    // best-effort — abnormal exits and network errors must not block close
  });
}
